/**
 * @deprecated import colors from @addi/foundation/dist/web/colors instead
 */
const Red = {
    normal: '#d12d17',
    light: '#ffecea'
};
export default Red;
//# sourceMappingURL=red.js.map